// EuroWrapper.js
import React from "react";

const EuroWrapper = ({ amount }: { amount: number }) => {
  // Format the amount as Euro currency using the correct locale
  const formattedAmount = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(amount);

  return <span style={{ fontWeight: "bold" }}>{formattedAmount}</span>;
};

export default EuroWrapper;
